var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 16.0845C0 7.24792 7.16344 0.0844727 16 0.0844727C24.8366 0.0844727 32 7.24792 32 16.0845C32 24.921 24.8366 32.0845 16 32.0845C7.16344 32.0845 0 24.921 0 16.0845Z",
    fill: "#F2146F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5459 9.96627C11.5223 8.89807 10.7584 8.08447 9.51803 8.08447C8.27761 8.08447 7.46667 8.89807 7.46667 9.96627C7.46667 11.0123 8.25365 11.8494 9.47096 11.8494H9.49413C10.7584 11.8494 11.5459 11.0123 11.5459 9.96627Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.307 13.3364H7.68109V24.2309H11.307V13.3364Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2088 13.0806C22.5948 13.0806 24.3836 14.638 24.3836 17.9843L24.3835 24.2309H20.7577V18.4023C20.7577 16.9383 20.233 15.9393 18.9204 15.9393C17.9186 15.9393 17.3219 16.6128 17.0599 17.2633C16.964 17.4964 16.9405 17.8212 16.9405 18.1468V24.2312H13.3141C13.3141 24.2312 13.3619 14.359 13.3141 13.3367H16.9405V14.8798C17.4217 14.138 18.2836 13.0806 20.2088 13.0806Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/LINKEDIN.b9f3c0590c30a9b626d9ed56727b959a.svg";
export { ForwardRef as ReactComponent };